module.exports = __webpack_public_path__ + "img/cbd-bath-bomb.6b099a4e.jpg";